import { j as e } from "./atoms-v218.js";
import { forwardRef as K, useState as D, useContext as Q, useCallback as k, useRef as U } from "react";
import W from "./atoms-v2122.js";
import { Button as G } from "./atoms-v26.js";
import { Icon as L } from "./atoms-v217.js";
import { InputContainer as X } from "./atoms-v2114.js";
import { InputHelper as d } from "./atoms-v220.js";
import { InputInterior as Y } from "./atoms-v2128.js";
import { InputLabel as Z } from "./atoms-v2129.js";
import { NumberInputSkeleton as T } from "./atoms-v2711.js";
import { FormGroupContext as ee } from "./atoms-v2130.js";
import { useMergedRefs as te } from "./atoms-v2712.js";
import { InputOutlineStyled as re, InputContainer as se, Input as ne, Actions as oe } from "./atoms-v2713.js";
const ie = K(
  ({
    className: N = "",
    colorTheme: r = "light",
    defaultValue: y = "0",
    disabled: u = !1,
    disabledButton: C,
    error: c,
    helperText: m,
    id: v,
    isSkeleton: B = !1,
    label: P,
    max: n,
    min: o = "0",
    name: a,
    onBlur: j,
    onFocus: I,
    readOnly: p = !1,
    step: q = "1",
    variant: i = "productive",
    ...z
  }, M) => {
    const [l, O] = D(y), [F, S] = D(!1), { isGroupedInput: h } = Q(ee), A = k((t) => {
      O(W(t, "value", "0"));
    }, []), s = U(null), H = te([M, s, A]), E = k(
      (t) => {
        var R, $;
        if (n && +t > +n || o && +t < +o || s === null || !s.current || Object === void 0)
          return !1;
        const f = (R = Object.getOwnPropertyDescriptor(s.current, "value")) == null ? void 0 : R.set, J = Object.getPrototypeOf(s.current), g = ($ = Object.getOwnPropertyDescriptor(J, "value")) == null ? void 0 : $.set;
        f && f !== g && g ? g.call(s.current, t) : f && f.call(s.current, t), s.current.dispatchEvent(
          new Event("input", {
            bubbles: !0
          })
        ), O(String(t));
      },
      [n, o]
    ), V = (t) => {
      S(!1), j && typeof j == "function" && j(t);
    }, _ = (t) => {
      S(!0), I && typeof I == "function" && I(t);
    };
    if (B)
      return /* @__PURE__ */ e.jsx(T, { helperText: m, variant: i });
    const b = !!c, w = l !== "", x = `${a}_errormessage`;
    return /* @__PURE__ */ e.jsxs(X, { className: N, variant: i, children: [
      /* @__PURE__ */ e.jsxs(
        re,
        {
          colorTheme: r,
          isDisabled: u || p,
          isErrored: b,
          isFocused: F && !p,
          isGroupedInput: h,
          variant: i,
          children: [
            /* @__PURE__ */ e.jsx(
              Z,
              {
                colorTheme: r,
                hasValue: w,
                htmlFor: v || a,
                isDisabled: u,
                isFocused: F,
                variant: i,
                children: P
              }
            ),
            /* @__PURE__ */ e.jsxs(Y, { children: [
              /* @__PURE__ */ e.jsx(se, { children: /* @__PURE__ */ e.jsx(
                ne,
                {
                  $colorTheme: r,
                  $variant: i,
                  "aria-invalid": b,
                  defaultValue: y,
                  disabled: u,
                  id: v || a,
                  max: n,
                  min: o,
                  name: a,
                  onBlur: V,
                  onFocus: _,
                  readOnly: p,
                  ref: H,
                  step: q,
                  type: "number",
                  ...b && { "aria-describedby": x },
                  ...z
                }
              ) }),
              /* @__PURE__ */ e.jsxs(oe, { $colorTheme: r, $variant: i, children: [
                /* @__PURE__ */ e.jsx(
                  G,
                  {
                    iconOnly: !0,
                    ariaLabel: "Decrease amount",
                    colorTheme: r,
                    disabled: u || !!(o && +l <= +o) || p || C === "decrease",
                    onClick: () => E(+l - 1),
                    shape: "square",
                    variant: "ghost",
                    children: /* @__PURE__ */ e.jsx(L, { name: "minus", size: "medium" })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  G,
                  {
                    iconOnly: !0,
                    ariaLabel: "Increase amount",
                    colorTheme: r,
                    disabled: u || !!(n && +l >= +n) || p || C === "increase",
                    onClick: () => E(+l + 1),
                    shape: "square",
                    variant: "ghost",
                    children: /* @__PURE__ */ e.jsx(L, { name: "add", size: "medium" })
                  }
                )
              ] })
            ] }),
            h ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(d, { isGroupedInput: !0, colorTheme: r, children: !c && m }),
              /* @__PURE__ */ e.jsx(d, { isError: !0, isGroupedInput: !0, colorTheme: r, id: x, children: c })
            ] }) : null
          ]
        }
      ),
      h ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(d, { colorTheme: r, children: !c && m }),
        /* @__PURE__ */ e.jsx(d, { isError: !0, colorTheme: r, id: x, children: c })
      ] })
    ] });
  }
);
ie.displayName = "NumberInput";
export {
  ie as NumberInput
};
